import { Container } from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  Button,
  Checkbox,
  PasswordInput,
  Text,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";

import { Colors, LogoM } from "../../Lib/Data";
import { Endpoints } from "../../Lib/Endpoints";
import {
  DefaultErrorNotification,
  parseString,
  validateEmail,
} from "../../Lib/Methods";
import { NonPaginatedResponse } from "../../Lib/Responses";
import { LoginResponseProps } from "../../Lib/Types";
import { PerformRequest } from "../../Lib/usePerformRequest";
import "./styles.scss";
const Login: React.FC = () => {
  const navigate = useNavigate();
  interface LoginFormProps {
    email: string;
    password: string;
  }
  const loginForm = useForm<LoginFormProps>({
    initialValues: {
      email: "",
      password: "",
    },
    validate: {
      email: (value) =>
        validateEmail(value) ? null : "Please enter a valid email!",
      password: (value) =>
        value && value.length >= 6 ? null : "At LEAST 6 characters!",
    },
  });
  const [isKeepAdminLoggedIn, setKeepAdminLoggedIn] = useState<boolean>(false);
  const [isLoggingIn, setLoggingIn] = useState<boolean>(false);
  // IF THE USER SPECIFIES KEEP LOGGED IN, GENERATE LONGER LASTING TOKEN
  const LoginAdmin = async () => {
    const { hasErrors: formHasErrors } = loginForm.validate();
    if (!formHasErrors) {
      const { email, password } = loginForm.values;
      setLoggingIn(true);
      const r = await PerformRequest<NonPaginatedResponse<LoginResponseProps>>({
        method: "POST",
        route: Endpoints.GetLogin(),
        data: {
          email: parseString(email, true),
          password: password,
          stayLoggedIn: isKeepAdminLoggedIn,
        },
        callback: () => {
          setLoggingIn(false);
        },
      });
      setLoggingIn(false);
      if (r) {
        if (r.status === 200) {
          localStorage.setItem("t", r.data.data.token);
          navigate("/dashboard");
        } else if (r.status === 404) {
          DefaultErrorNotification("Account does not exist!");
        } else if (r.status === 401) {
          DefaultErrorNotification("Invalid email or password");
        }
      }
    }
  };

  const inputProps = {
    className: "input",
    spellCheck: false,
  };

  return (
    <Container maxWidth="xs">
      <div className="login-container flex-row align-center justify-between width-100">
        <div className="right flex-col align-center justify-between">
          <Text fw={500} fz={18} c={Colors.BlackPrimary}>
            Admin Dashboard
          </Text>
          <img src={LogoM} alt="" className="logo" />
          <Text c={Colors.BlackPrimary} fz={14}>
            Login to continue
          </Text>
          <TextInput
            type="email"
            name="email"
            label="Email Address"
            placeholder="you@email.com"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                LoginAdmin();
              }
            }}
            {...inputProps}
            {...loginForm.getInputProps("email")}
          />
          <PasswordInput
            label="Password"
            placeholder="Enter your password"
            {...inputProps}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                LoginAdmin();
              }
            }}
            {...loginForm.getInputProps("password")}
          />
          <div className="flex-row align-center justify-start width-100">
            <Checkbox
              checked={isKeepAdminLoggedIn}
              onChange={(e) => {
                setKeepAdminLoggedIn(e.target.checked);
              }}
            />
            <Text
              onClick={() => {
                setKeepAdminLoggedIn(!isKeepAdminLoggedIn);
              }}
              c={Colors.BlackPrimary}
              ml={10}
              fz={15}
            >
              Keep me logged in
            </Text>
          </div>
          <Button
            fullWidth
            onClick={LoginAdmin}
            color={Colors.GreenPrimary}
            loading={isLoggingIn}
          >
            Continue
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default Login;
